import "bootstrap/dist/js/bootstrap.bundle.min.js";

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import "../../css/organizer.css";
import Degree45 from "../../gallery/icons/grey45degree.png";

import { Modal } from "bootstrap";

import { updateEvent, resetEvent } from "../../app/features/event/eventSlice";
import { resetAskSignup, resetGuest, setAskTicket } from "../../app/features/user/userSlice";
import { resetTimer } from "../../app/features/timer/timerSlice";
import { setActiveLink } from "../../app/features/nav/navSlice";

import EventTicketsModal from "../events/EventTicketsModal";
import GeoAlt from "../../gallery/icons/geoalt.svg";
import InfoCircle from "../../gallery/icons/info-circle.png";
import Calendar from "../../gallery/icons/calender.svg";
import Alarm from "../../gallery/icons/alarm.svg";
import BuyTicket from "../../gallery/icons/buy-ticket.svg";
import LeftCarouselArrow from "../../gallery/icons/leftCarouselArrow.png";
import RightCarouselArrow from "../../gallery/icons/rightCarouselArrow.png";
import ArrowLeft from "../../gallery/icons/arrowLeft.png";
import ArrowRight from "../../gallery/icons/arrowRight.png";

function OrganizerUpcoming({ slug }) {
  const dispatch = useDispatch();

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(1);

  const currentEvent = useSelector((state) => state.event.currentEvent);

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    dispatch(setActiveLink("event"));
    dispatch(resetEvent());
    dispatch(resetTimer());
    fetchEvents(1);
  }, [slug]);

  const fetchEvents = async (pageNum = 1) => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${BASE_URL}/api/user/events/${slug}/upcoming?page=${pageNum}`, {
        headers: {
          Authorization: API_KEY,
          Accept: "application/json",
        },
      });

      const responseData = res.data.data || res.data || [];
      setEvents((prev) => [...prev, ...responseData]);

      const nextPage = (res.data.links && res.data.links.next) || (res.data.meta && res.data.meta.next_page_url);
      setHasMore(!!nextPage);
    } catch (err) {
      console.error("Error fetching upcoming events:", err);
      setError("Unable to fetch upcoming events. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = (e, idx, event) => {
    e.preventDefault();
    const currentUrl = `${window.location.origin}/events/${event.slug}`;

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => console.log("URL copied to clipboard!"))
        .catch((error) => console.error("Failed to copy URL: ", error));
    } else {
      fallbackCopyURL(currentUrl);
    }

    const myButton = document.getElementById(`copylinkbtn_${idx}`);
    myButton.className = "btn-copy-grey";
    myButton.innerHTML = `<img src=${Degree45} alt=""/> Copied to clipboard`;
    myButton.setAttribute("disabled", true);

    setTimeout(() => {
      myButton.className = "btn-copy-grey";
      myButton.innerHTML = `<img src=${Degree45} alt=""/> Copy link`;
      myButton.removeAttribute("disabled");
    }, 5000);
  };

  const fallbackCopyURL = (url) => {
    const textArea = document.createElement("textarea");
    textArea.value = url;
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      console.log("URL copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy URL: ", error);
    }
    document.body.removeChild(textArea);
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchEvents(nextPage);
  };

  const goToTickets = (eventData) => {
    dispatch(updateEvent(eventData));
    dispatch(setAskTicket());
    dispatch(resetAskSignup());
    dispatch(resetGuest());
    dispatch(resetTimer());

    setTimeout(() => {
      const modalEl = document.getElementById("appModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }, 200);
  };

  const dateFormat = (d, type = 0) => {
    let date = new Date(d);
    const dayOfWeek = date.toLocaleString("en-UK", { weekday: "short" });
    const month = date.toLocaleString("en-UK", { month: "short" });
    const year = date.getFullYear();
    const day = date.getDate();
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    if (type === 1) return `${dayOfWeek}, ${day} ${month} ${year}, ${hours}:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;
    if (type === 4)
      return `${day} ${date.toLocaleString("en-UK", {
        month: "long",
      })} ${year}`;
    return `${dayOfWeek}, ${day} ${month}, ${hours}:${minutes < 10 ? "0" + minutes : minutes}${ampm}`;
  };

  if (error) return null;
  return (
    <>
      <div className="container ">
        {loading && events.length === 0 && (
          <div className="loader-in-component-body">
            <BeatLoader color="#C6153B" />
          </div>
        )}
        {events.map((event, idx) => (
          <div key={idx} className="mb-5 mt-5">
            <div className="row">
              {((event.gallery && event.gallery.length > 0) || event.image_name) && (
                <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
                  <div>
                    {event.gallery && event.gallery.length > 0 && (
                      <div
                        id={`carousel_${idx}`}
                        className="carousel slide"
                        data-bs-ride={event.gallery.length > 1 ? "carousel" : ""}
                        data-bs-interval={event.gallery.length > 1 ? "4000" : ""}
                      >
                        {event.gallery.length > 1 && (
                          <div className="carousel-indicators">
                            {event.gallery.map((_, index) => (
                              <button
                                key={`indicator_${index}`}
                                type="button"
                                data-bs-target={`#carousel_${idx}`}
                                data-bs-slide-to={index}
                                className={index === 0 ? "active" : ""}
                                aria-current={index === 0 ? "true" : "false"}
                                aria-label={`Slide ${index + 1}`}
                              ></button>
                            ))}
                          </div>
                        )}

                        <div className="carousel-inner carousel-inner-height align-content-center">
                          {event.gallery.map((element, index) => {
                            const isActive = index === 0 ? "active" : "";
                            const bgImage = `${element.image_path}/${element.image_name}`;
                            return (
                              <div
                                className={`carousel-item ${isActive} carousel-wrapper`}
                                key={`carousel_${index}`}
                              >
                                <div
                                  className="carousel-bg-blur"
                                  style={{ backgroundImage: `url(${bgImage})` }}
                                />
                                <div className="carousel-bg-gradient" />
                                <div className="carousel-image-container">
                                  <img
                                    src={bgImage}
                                    alt={event.name || "Event Image"}
                                    className="img-fluid shadow-lg carousel-event-image"
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {event.gallery.length > 1 && (
                          <>
                            <div className="carousel-nav hidden-xs">
                              <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target={`#carousel_${idx}`}
                                data-bs-slide="prev"
                              >
                                <span aria-hidden="true">
                                  <img src={LeftCarouselArrow} alt="" />
                                </span>
                                <span className="visually-hidden">Previous</span>
                              </button>
                              <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target={`#carousel_${idx}`}
                                data-bs-slide="next"
                              >
                                <span aria-hidden="true">
                                  <img src={RightCarouselArrow} alt="" />
                                </span>
                                <span className="visually-hidden">Next</span>
                              </button>
                            </div>

                            <div className="carousel-nav hidden-md">
                              <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target={`#carousel_${idx}`}
                                data-bs-slide="prev"
                              >
                                <span aria-hidden="true">
                                  <img src={ArrowLeft} alt="" />
                                </span>
                                <span className="visually-hidden">Previous</span>
                              </button>
                              <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target={`#carousel_${idx}`}
                                data-bs-slide="next"
                              >
                                <span aria-hidden="true">
                                  <img src={ArrowRight} alt="" />
                                </span>
                                <span className="visually-hidden">Next</span>
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    )}


                    {(!event.gallery || event.gallery.length === 0) && event.image_name && (
                      <div className="carousel slide">
                        <div className="carousel-inner carousel-inner-height align-content-center">
                          <div className="carousel-item active carousel-wrapper">
                            <div className="carousel-bg-blur" style={{ backgroundImage: `url(${event.image_path})` }} />
                            <div className="carousel-bg-gradient" />
                            <div className="carousel-image-container">
                              <img src={event.image_path} alt={event.name || "Event Image"} className="img-fluid shadow-lg carousel-event-image" />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
                <div>
                  {event.tickets && new Date(event.end_date).getTime() >= new Date().getTime() && (
                    <>
                      <button className="btn btn-event-modal" onClick={() => goToTickets(event)}>
                        <img src={BuyTicket} alt="" className="me-3" />
                        Buy tickets
                      </button>
                    </>
                  )}
                </div>

                <h3 className="detail-event-title">{event.name}</h3>
                <p>
                  <button id={`copylinkbtn_${idx}`} className="btn-copy-grey" onClick={(e) => handleCopy(e, idx, event)}>
                    <img src={Degree45} alt="" /> &nbsp;Copy link
                  </button>
                </p>
                <p className="location-on-detail paragraph-margin-sm">
                  <img src={GeoAlt} alt="" /> &nbsp;
                  {event.address1 ? `${event.address1}, ` : ""}
                  {event.location} {event.postal_code && ` - ${event.postal_code}`}
                </p>
                <p className="location-on-detail paragraph-margin-sm">
                  <img src={InfoCircle} alt="" /> &nbsp; Organized by <Link to={`/events/${event.user_slug}`}>{event.user_name}</Link>
                </p>

                {parseInt(event.show_start_date) === 1 && (
                  <p className="location-on-detail">
                    <img src={Calendar} alt="" /> &nbsp; {dateFormat(event.start_date, 1)}
                  </p>
                )}
                {event.last_entry_time && parseInt(event.show_start_date) === 1 && (
                  <p className="location-on-detail">
                    <img src={Alarm} alt="" /> &nbsp; Doors close at {dateFormat(event.last_entry_time, 1)}
                  </p>
                )}

                <p className="paragraph-margin-sm">
                  <span className="badge rounded-pill card-business">{event.category}</span>
                  {event.adult_event && <span className="badge rounded-pill for-adults">18+ only</span>}
                </p>
              </div>
            </div>

            <div className="row">
              <p
                className="detail-desc mt-3"
                dangerouslySetInnerHTML={{
                  __html: event.detail ? event.detail.replace(/\n/g, "<br />") : "",
                }}
              />
            </div>

            <hr className="mt-1 mb-0" />
          </div>
        ))}

        {hasMore && !loading && (
          <div className="text-center mt-5">
            <button onClick={handleLoadMore} className="btn btn-dark px-4 py-2 rounded-pill">
              Load More
            </button>
          </div>
        )}
      </div>

      {currentEvent && currentEvent.tickets && <EventTicketsModal />}
    </>
  );
}

export default OrganizerUpcoming;
